import _ from 'underscore'
import URI from 'urijs'
import Backbone from '@polleverywhere/backbone'
import InstanceMixin, { Common } from './mixins/_instance_common'

/**
 * Generates the Firehose channel path for instance data.
 * @param {string} path Additional path to append to the base URL.
 * @return {string} Always suffixed with a `.json` extension
 */
function getInstanceChannelPath (path = '') {
  return URI('/instances')
    .segment(this.activity.type() + 's')
    .segment(this.activity.get('participant_key'))
    .suffix('json')
    .toString()
}

/**
 * Generates the Firehose channel path for activity data.
 * @param {string} path Additional path to append to the base URL.
 * @return {string} Always suffixed with a `.json` extension
 */
function getActivityChannelPath () {
  return URI('/')
    .segment(this.activity.type() + 's')
    .segment(this.activity.get('shared_key'))
    .segment('participant')
    .suffix('json')
    .toString()
}

export default class ParticipantInstance extends Backbone.Model {
  initialize (attrs = {}, options = {}) {
    _.extend(this, InstanceMixin(this))

    /**
     * Contains reference to the internal activity model.
     * @type {Backbone.Model}
     */
    this.activity = options.activity

    // Parse the activity's attributes so it can be normalized.
    this.parse(this.activity.attributes)
  }

  get idAttribute () {
    return Common.getIdAttribute.call(this)
  }

  get urlRoot () {
    return Common.getUrlRoot.call(this)
  }

  /**
   * Read-only property indicating the instance type, which is used to determine
   * the correct resource paths, keys, etc.
   * @return {string}
   */
  get type () {
    return 'participant'
  }

  /**
   * Returns the list of Firehose channels this instance subscribes to:
   * => `/:plural_activity_type/:shared_key/shared.json`
   * => `/instances/:plural_activity_type/:participant_key.json`
   * @return {string[]}
   */
  get channels () {
    Common.requireAttrs(this.activity.attributes, [
      'shared_key',
      'participant_key'
    ])

    const instanceChannel = getInstanceChannelPath.call(this)
    const activityChannel = getActivityChannelPath.call(this)

    return [
      instanceChannel,
      activityChannel
    ]
  }

  parse (data = {}, options = {}) {
    Common.parseActivity.call(this, data, options)

    // Keep this model free of attributes.
    return {}
  }
}
